<template>
  <div class="control has-icons-left">
    <div class="select" :class="{ 'flow-select--disabled': isReportLoading }">
      <select v-model="flowId" @change="setFlowForReports(flowId)" :disabled="isReportLoading">
        <option v-for="flow of reportFlowsOptions" :key="flow.id" :value="flow.id">{{ flow.name }}</option>
      </select>
      <span class="icon is-left select-icon">
        <FlowIcon class="icon-1-3x dropdown-icons icon-adjustment flow-icon-adjustment" />
      </span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { LOAD_FLOW_LIST_OPTIONS } from '@/store/reports/actionTypes';
import { SET_REPORTING_FLOW } from '@/store/reports/mutationTypes';
import FlowIcon from 'vue-material-design-icons/Waves.vue';
import { useStore } from 'vuex';
import { computed, onBeforeMount, onMounted, ref, watch } from 'vue';

const store = useStore();
const reportFlowsOptions = computed(() => store.getters.reportFlowsOptions);
const selectedFlowId = computed(() => store.getters.selectedFlowId);
const isReportLoading = computed(() => store.getters.isReportLoading);
const loadFlows = () => store.dispatch(LOAD_FLOW_LIST_OPTIONS);
const setFlowForReports = (flowId: string) => store.commit(SET_REPORTING_FLOW, flowId);

const flowId = ref('all');

onBeforeMount(() => (flowId.value = selectedFlowId.value));
onMounted(() => loadFlows());
watch(selectedFlowId, (newFlowId) => (flowId.value = newFlowId));
</script>

<style lang="scss" scoped>
.select {
  margin-left: 20px;

  select {
    min-width: 300px;
  }
}

.flow-select--disabled {
  opacity: 0.5;

  select[disabled] {
    background-color: #ffffff;
    opacity: 1;
  }
}

.icon-adjustment {
  margin-left: -10px;
}

.flow-icon-adjustment {
  margin-top: -4px;
}
</style>
